

function Footer() {
    return (
        <div id="footer">
            <pre>✴             ✴              ✴</pre>
        </div>
    );
}

export default Footer;
